import { useLocation } from "react-router-dom";
import { Seo } from "@/components/seo/Seo";
import { useSeoConfig } from "@/hooks/useSeoConfig";

/**
 * Applies admin-managed SEO overrides for the current public route at runtime.
 *
 * Reads the per-route config (index/noindex + optional title/description) and
 * renders the shared <Seo> head manager only when the route has an override or
 * is flagged noindex. Pages without an override keep their own <Seo> defaults,
 * so there is no duplicate/conflicting head management. Mounted once inside the
 * Router in App.
 */
export function SeoManager() {
  const location = useLocation();
  const { data: config } = useSeoConfig();

  const route = config?.routes[location.pathname];
  if (!route) return null;

  const noindex = route.index === false;
  if (!noindex && !route.title && !route.description) return null;

  const title = route.title || config?.defaults.defaultTitle;
  const description = route.description || config?.defaults.defaultDescription;

  return (
    <Seo
      title={title}
      description={description}
      url={location.pathname}
      image={config?.defaults.ogImage}
      noindex={noindex}
    />
  );
}
